module.exports = "<span class=\"input-group-text cursor-pointer\" style=\"margin-top: 6px; border:0;\">\r\n    <i class=\"ti-close\"></i>\r\n</span>"